export default __webpack_public_path__ + "static/media/Ballroll_00038.c013ee58.png";